import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';

interface ChatPostState {
	chatResponse: any;
	status: boolean;
	error: string | null;
}

const initialState: ChatPostState = {
	chatResponse: {},
	status: false,
	error: null
};

const chatPost = createAsyncThunk<any, any>('chatPost/chatPost', async (payload, thunkAPI) => {
	try {
		const response = await API.post(API_ENDPOINTS.CHAT_POST, payload);
		return response.data;
	} catch (error: any) {
		return error.response.data;
	}
});

const chatPostSlice = createSlice({
	name: 'chatPost',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(chatPost.pending, (state) => {
				state.status = true;
				state.error = null;
			})
			.addCase(chatPost.fulfilled, (state, action: PayloadAction<any>) => {
				state.status = false;
				state.chatResponse = action.payload;
			})
			.addCase(chatPost.rejected, (state, action) => {
				state.status = false;
				state.error = action.error.message || 'Failed to post chat data';
			});
	}
});

export { chatPost };
export const { reset: resetChatPost } = chatPostSlice.actions;
export const chatPostReducer = chatPostSlice.reducer;
